import { useLanguage } from '../i18n';

export function SupportPage(): JSX.Element {
  const { t } = useLanguage();

  return (
    <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
      <h1 className="text-3xl font-semibold">{t('support.title')}</h1>
      <div className="mt-8 grid gap-4">
        {[
          ['support.uploadTitle', 'support.uploadBody'],
          ['support.editTitle', 'support.editBody'],
          ['support.exportTitle', 'support.exportBody'],
          ['support.keyboardTitle', 'support.keyboardBody'],
          ['support.heicTitle', 'support.heicBody']
        ].map(([title, body]) => (
          <section key={title} className="rounded-lg border border-[color:var(--line)] bg-[color:var(--panel)] p-4">
            <h2 className="text-sm font-semibold">{t(title)}</h2>
            <p className="mt-2 text-sm leading-6 text-[color:var(--muted)]">{t(body)}</p>
          </section>
        ))}
      </div>
    </main>
  );
}
